import { Component } from '@angular/core';


@Component({
    selector: 'soft-date-time-range-input',
    imports: [],
    templateUrl: './date-time-range-input.component.html',
    styleUrl: './date-time-range-input.component.css'
})
export class DateTimeRangeInputComponent {}
